<template>
    <div>
        <Container class="md:py-20 lg:py-24 flex flex-col py-16">
            <h2 v-if="$slots.section" class="self-center my-0 text-base font-semibold leading-7 text-center text-blue-500">
                <slot name="section"></slot>
            </h2>
            <p v-if="$slots.title" class="mb-14 text-gray-body text-opacity-90 self-center mt-0 text-3xl font-medium leading-snug tracking-tight text-center">
                <slot name="title"></slot>
            </p>
            <div>
                <slot />
            </div>
        </Container>
    </div>
</template>

<script>
import Container from './container.vue';

export default {
    components: {
        Container,
    },
};
</script>
